import { render, staticRenderFns } from "./ThemifyIcons.vue?vue&type=template&id=4f8bea99"
import script from "./ThemifyIcons.vue?vue&type=script&lang=js"
export * from "./ThemifyIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports